<template>
  <div class="slideshow" v-if="slides">
    <div id="myCarousel" class="carousel slide" data-ride="carousel">
      <!-- Wrapper for slides -->
      <div class="carousel-inner">
        <div
          class="item min-vh-100"
          v-for="(slide, index) in slides"
          :class="{ active: index == 0 }"
          :key="index"
        >
          <img :src="slide.image" :alt="slide.title" style="width:100%;" />
        </div>
      </div>

      <!-- Left and right controls -->
      <a class="left carousel-control" href="#myCarousel" data-slide="prev">
        <span class="glyphicon glyphicon-chevron-left"></span>
        <span class="sr-only">Previous</span>
      </a>
      <a class="right carousel-control" href="#myCarousel" data-slide="next">
        <span class="glyphicon glyphicon-chevron-right"></span>
        <span class="sr-only">Next</span>
      </a>
    </div>
  </div>
</template>
<script>
// @ is an alias to /src
import Axios from "axios";
import APPURL from "../constant";
export default {
  data() {
    return {
      slides: {}
    };
  },
  mounted() {
    this.getSlides();
  },

  methods: {
    getSlides(url = APPURL.LINK + "slides") {
      Axios.get(url).then(response => {
        //this.slides = response.data.data.results;
        this.slides = response.data.data.results;
        // console.log(this.slides);
      });
    }
  },
  name: "SlideShow"
};
</script>
<style scoped lang="scss">
.carousel {
  padding: 0px !important;
  height: 476px !important;
}
.item {
  height: 476px !important;
}
.carousel-control.right,
.carousel-control.left {
  background-image: none !important;
  top: 40% !important;
}
.carousel-control {
  background: #208649;
  width: 40px !important;
  height: 40px !important;
  padding: 10px !important;
  border-radius: 6px;
  margin: 10px;
}
.carousel-control .glyphicon {
  padding-left: 5px;
  margin-top: -15px !important;
}
.glyphicon-chevron-left {
  margin-left: -20px !important;
}
@media (min-device-width: 320px) and (max-device-width: 480px) {
  .carousel-control.right,
  .carousel-control.left {
    background-image: none !important;
    top: 30% !important;
  }
  .item {
    height: 200px !important;
  }
  .carousel {
    height: 200px !important;
  }
  .carousel-control .glyphicon {
    padding-left: 5px;
    margin-top: -10px !important;
  }
  .glyphicon-chevron-left {
    margin-left: -15px !important;
  }
}
@media (max-device-width: 320px) {
  .carousel-control.right,
  .carousel-control.left {
    background-image: none !important;
    top: 30% !important;
  }
  .item {
    height: 150px !important;
  }
  .carousel {
    height: 150px !important;
  }
  .carousel-control .glyphicon {
    padding-left: 5px;
    margin-top: -10px !important;
  }
  .glyphicon-chevron-left {
    margin-left: -15px !important;
  }
}
</style>
